<template>
  <div class="sub-table">
    <el-row class="table-header" type="flex" align="middle">
      <el-col :span="6">时间</el-col>
      <el-col :span="18">产品信息</el-col>
    </el-row>
    <div class="table-item" v-for="item in mallExchangeGoods" :key="item.id">
      <el-row type="flex" align="middle">
        <el-col :span="6">
          <div style="margin-bottom:5px">
            {{ baseMethods.enToChinese(item.status, userConfirmationOptions) }}
          </div>
          <div v-if="item.confirmDate" style="margin-bottom:5px">({{ item.confirmDate | rTime }})</div>
          <div v-if="item.code">
            换货订单：{{ item.code }}
          </div>
        </el-col>
        <el-col :span="18">
          <el-row
            type="flex"
            align="middle"
            v-for="goods in item.mallExchangeGoodsItems"
            :key="goods.id + goods.returnGoods"
          >
            <el-col :span="20">
              <el-row type="flex" align="middle">
                <img
                  style="width: 50px; margin-right: 5px;"
                  :src="goods.imgUrl"
                />
                <div class="goods-info-right" style="position:relative">
                  <div style="width: 80%">{{ goods.name }}</div>
                  <div :class="goods.returnGoods ? 'returns' : 'exchange'">
                    {{ goods.returnGoods ? "退" : "换" }}
                  </div>
                </div>
              </el-row>
            </el-col>
            <el-col :span="4">{{ "X" + goods.quantity }}</el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { userConfirmationOptions } from "./contants";
export default {
  props: {
    mallExchangeGoods: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      userConfirmationOptions,
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
// 设置透明边框占位
.el-col {
  border: 1px solid transparent;
}
.sub-table {
  color: #333333;
  text-align: center;
  .el-row .el-col {
    font-size: 12px;
  }
  .table-header {
    border: 1px solid #d7d7d7;
    background-color: #f9fafb;
    height: 40px;
    margin-bottom: 10px;
  }
  .table-item {
    padding: 10px 0;
    border: 1px solid #d7d7d7;
    border-bottom: none;
    &:last-child {
      border-bottom: 1px solid #d7d7d7;
    }
    .goods-info-right {
      width: 100%;
      text-align: left;
    }
    &-state {
      border-top: 1px solid #d7d7d7;
      padding-top: 10px;
      padding-left: 35px;
      margin-top: 10px;
      font-size: 12px;
      text-align: left;
    }
  }
}
.order-blue-test {
}
.redFlag {
  z-index: 50;
  width: 50px;
  text-align: center;
  margin-top: 35px;
  font-size: 12px;
  line-height: 18px;
}
.returns {
  position: absolute;
  top: 10px;
  right: 0px;
  background-color: #d9001b;
  padding: 3px 5px;
  border-radius: 15px;
  color: #fff;
}
.exchange {
  position: absolute;
  top: 10px;
  right: 0px;
  background-color: #70b603;
  padding: 3px 5px;
  border-radius: 15px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/user/children/ExchangeRecordPhone.vue